export function to12h(time24) {
  if (!time24) return '';
  const [h, m] = time24.split(':');
  let hours = parseInt(h, 10);
  const modifier = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${hours}:${m} ${modifier}`;
}

export function utilBadgeStyle(pct) {
  if (pct === null || pct === undefined) return { background: '#f3f4f6', color: '#6b7280' };
  if (pct >= 70) return { background: '#dcfce7', color: '#15803d' };
  if (pct >= 40) return { background: '#fef3c7', color: '#b45309' };
  return { background: '#fee2e2', color: '#b91c1c' };
}

// Sequential single-hue ramp (blue, light -> dark) for magnitude encoding —
// darker bars mean a busier hour, lighter bars mean a quieter one.
const SEQUENTIAL_BLUE = [
  { max: 12.5, hex: '#cde2fb' },
  { max: 25, hex: '#9ec5f4' },
  { max: 37.5, hex: '#6da7ec' },
  { max: 50, hex: '#3987e5' },
  { max: 62.5, hex: '#2a78d6' },
  { max: 75, hex: '#1c5cab' },
  { max: 87.5, hex: '#184f95' },
  { max: 100.01, hex: '#0d366b' },
];

export function seqColor(pct) {
  if (pct === null || pct === undefined) return '#e1e0d9';
  const found = SEQUENTIAL_BLUE.find((b) => pct <= b.max);
  return found ? found.hex : '#0d366b';
}
